import { useMutation, useQuery } from "@tanstack/react-query";
import apiClient from "./apiClient";
import { APIErrorResponse } from "src/types/generic";

export const useGetProfile = () =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: ["get-user-profile"],
    queryFn: async () => {
      return apiClient.get(`/api/user/profile`);
    },
  });

export const useInitiateConnectToFoodics = () =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: ["initiate-foodics-connect"],
    queryFn: async () => {
      return apiClient.get(`/api/foodics/initiate`);
    },
    enabled: false,
  });

export const useConnectFoodicsCallback = () =>
  useMutation<any, APIErrorResponse, { code: string; state: string }>({
    mutationFn: async (data) => {
      return apiClient.post(`/api/foodics/settle`, data);
    },
  });
